import { AType, summon } from "@silversea-ssc/functional-support"
import { AirFare } from "../air-fare"
import * as Amount from "../amount"
import * as F from "fp-ts/function"
import * as RONEA from "fp-ts/ReadonlyNonEmptyArray"

const sumAllAmount = RONEA.concatAll(Amount.SemigroupSum)

const _AirFareOptionDetail = summon((F) =>
    F.interface(
        {
            paxNumber: F.number(),
            amount: Amount.Amount(F),
            isPromotional: F.boolean(),
        },
        "AirFareOptionDetail",
    ),
)
export type AirFareOptionDetail = AType<typeof _AirFareOptionDetail>

const isPromotional = _AirFareOptionDetail.lensFromProp("isPromotional")
const amount = _AirFareOptionDetail.lensFromProp("amount")

export const AirFareOptionDetail = /* @__PURE__ */ Object.assign(_AirFareOptionDetail, {
    amount: amount.get,
    isPromotional: isPromotional.get,
})

export const _AirFareOption = summon((F) =>
    F.interface(
        {
            airFare: AirFare(F),
            detailByGuest: F.nonEmptyArray(AirFareOptionDetail(F)),
        },
        "AirFareOption",
    ),
)
export type AirFareOption = AType<typeof _AirFareOption>

const firstGuestDetail = (cruiseAirFare: AirFareOption) => RONEA.head(cruiseAirFare.detailByGuest)

export const AirFareOption = /* @__PURE__ */ Object.assign(_AirFareOption, {
    totalAmount: (option: AirFareOption): Amount.Amount =>
        F.pipe(option.detailByGuest, RONEA.map(AirFareOptionDetail.amount), sumAllAmount),
    isIncluded: F.flow(firstGuestDetail, AirFareOptionDetail.amount, Amount.isZero),
    hasAirFare:
        (airFare: AirFare) =>
        (option: AirFareOption): boolean =>
            option.airFare === airFare,
    isPromotional: F.flow(firstGuestDetail, AirFareOptionDetail.isPromotional),
    firstGuestDetail,
    isUpgradeFor:
        (base: AirFareOption) =>
        (maybeUpgrade: AirFareOption): boolean =>
            AirFare.isUpgrade(base.airFare, maybeUpgrade.airFare),
})
